import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const createManager: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { userApi },
) =>
  action$.pipe(
    ofType(actions.CREATE_MANAGER_ACTIONS.REQUESTED),
    switchMap(({ payload: { manager } }) =>
      userApi.createManager(manager).pipe(
        switchMap(({ newManager }) =>
          of(
            actions.createManagerSucceeded(newManager),
            actions.removeEditManager(),
          ),
        ),
        catchError(error => of(actions.createManagerFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/epics/createManager.ts